var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useQuery, useReactiveVar } from '@apollo/client';
import { USER_SHORT } from 'common/graphql/queries/user/user-short';
import UserAvatar from 'components/UserAvatar/UserAvatar';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { userProfileDataVar } from 'utils/apollo/reactivities/userProfileDataVar';
var IsYourCell = function () {
    var t = useTranslation().t;
    return _jsx("p", __assign({ className: "text-green text-12" }, { children: t('Это вы') }), void 0);
};
var UserNameCell = function (_a) {
    var _b, _c, _d, _e, _f;
    var userName = _a.userName, userId = _a.userId, userDisplayName = _a.userDisplayName;
    var currentUserId = (_b = useReactiveVar(userProfileDataVar).userProfile) === null || _b === void 0 ? void 0 : _b.id;
    var data = useQuery(USER_SHORT, {
        variables: userId
            ? {
                id: userId
            }
            : {
                userName: userName
            }
    }).data;
    return (_jsxs("div", __assign({ className: "flex flex-row space-x-5 items-center" }, { children: [_jsx(UserAvatar, { style: "cursor-pointer xs:w-28 xs:h-28 text-16", firstName: (_d = (_c = data === null || data === void 0 ? void 0 : data.user) === null || _c === void 0 ? void 0 : _c.mainSettings) === null || _d === void 0 ? void 0 : _d.firstName, profilePhoto: (_f = (_e = data === null || data === void 0 ? void 0 : data.user) === null || _e === void 0 ? void 0 : _e.mainSettings) === null || _f === void 0 ? void 0 : _f.profilePhoto }, void 0), _jsx(Link, __assign({ to: "/profile/".concat(userName), onClick: function (e) { return e.stopPropagation(); }, className: "xs:underline md:no-underline md:hover:underline" }, { children: userDisplayName }), void 0), currentUserId && currentUserId === userId && _jsx(IsYourCell, {}, void 0)] }), void 0));
};
export default UserNameCell;
